module.exports = __webpack_public_path__ + "static/media/tlyfeImageText2.a3329457.png";